<header class="flex header">
  <h2>{{ 'Fabric_Alias_Manage_Modal_Title' | translateWF: 'Fabric Aliases' }}</h2>
  <p-button icon="pi pi-times" (click)="onClose()" />
</header>
<section class="content">
  <h3>({{ fabric?.fabricCode }}) {{ fabric?.longDescription }}</h3>
  <section>
    <h3 class="line">{{ 'Fabric_Alias_Manage_Modal_Title' | translateWF: 'Aliases' }}</h3>
    <div class="col-sm">
      <p-tag *ngFor="let alias of editableAliases" [value]="alias.alias" [rounded]="true" (click)="editAlias(alias)" class="cursor-pointer self-start"></p-tag>
    </div>

    <div class="row-sm mt-4 items-center">
      <input type="text" pInputText [formControl]="alias" />
      <p-button icon="pi pi-plus" [label]="'Add' | translateWF: 'Add'" (click)="saveAlias()" />
      <p-button icon="pi pi-ban" [label]="'Cancel' | translateWF: 'Cancel'" (click)="cancelEdit()" />
    </div>
  </section>
</section>
<footer class="row-end-stretch gap-4">
  <p-button class="w-full" [label]="'Save' | translateWF: 'Save'" [disabled]="!canSave()" (click)="onSave()" />
  <p-button class="w-full" [label]="'Exit' | translateWF: 'Exit'" variant="outlined" (click)="onClose()" />
</footer>
